import { EWindowsType } from '../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectWindowsFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const WindowsContainer: FC = () => {
  const { label, value, options } = useSelector(selectWindowsFilter);

  const onChange = useFilterChangeCallback();

  const handleWindowsChange = useCallback(
    (newValue: EWindowsType | null) => {
      onChange({ action: 'setWindowsType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter options={options} value={value} onFilterChange={handleWindowsChange} />
    </AdvancedFilterRow>
  );
};
